import { useEffect, useRef, useState } from 'react';

import { apiUrl, fetchJson } from '../../apiBase';

const useMaarifInitLists = ({ schoolId, notifyError }) => {
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loadingInit, setLoadingInit] = useState(false);
  const reqIdRef = useRef(0);

  useEffect(() => {
    setClasses([]);
    setCourses([]);

    if (!schoolId) return;

    const rid = ++reqIdRef.current;
    const run = async () => {
      setLoadingInit(true);
      try {
        const [clsRes, courseRes] = await Promise.all([
          fetchJson(apiUrl(`/admin/classes/${encodeURIComponent(schoolId)}`)),
          fetchJson(apiUrl('/admin/maarif/lessons')),
        ]);
        if (rid !== reqIdRef.current) return;
        if (!clsRes.ok) throw new Error('classes');
        if (!courseRes.ok) throw new Error('courses');

        const cls = await clsRes.json();
        const courseRows = await courseRes.json();

        const clsItems = (cls || [])
          .map((c) => ({
            id: c?.id,
            name: String(c?.name || ''),
            grade_level: String(c?.grade_level ?? ''),
          }))
          .filter((x) => x?.id != null && x?.name);

        clsItems.sort((a, b) => String(a.name).localeCompare(String(b.name), 'tr-TR'));
        setClasses(clsItems);

        const courseItems = (courseRows || [])
          .filter((r) => r && r.id != null)
          .map((r) => ({
            id: r.id,
            code: r.code || null,
            name: String(r.name || ''),
            is_active: !!r.is_active,
          }))
          .sort((a, b) => String(a.name).localeCompare(String(b.name), 'tr-TR'));
        setCourses(courseItems);
      } catch (e) {
        if (rid !== reqIdRef.current) return;
        notifyError && notifyError('Başlangıç verileri yüklenemedi');
        setClasses([]);
        setCourses([]);
      } finally {
        if (rid !== reqIdRef.current) return;
        setLoadingInit(false);
      }
    };

    run();
  }, [schoolId, notifyError]);

  return { classes, courses, loadingInit };
};

export default useMaarifInitLists;
